"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// NotificationPreferenceControls.tsx
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var ExpandMore_1 = __importDefault(require("@mui/icons-material/ExpandMore"));
// @ts-ignore
var Lang_js_1 = require("../../Lang.js");
var bootstrap_1 = require("../bootstrap");
var preferencesStore_1 = require("../storage/preferencesStore");
var api_1 = require("../api");
var Toast_1 = __importDefault(require("../../Generic/Toast"));
var KindChannelToggles_1 = __importDefault(require("./KindChannelToggles"));
var displayKindTitle = function (kind) {
    var foundKind = (0, preferencesStore_1.getKinds)().find(function (k) { return k.kind === kind; });
    return foundKind ? foundKind.title : kind;
};
var NotificationPreferenceControls = function (_a) {
    var _b = _a.userId, userId = _b === void 0 ? 0 : _b, kind = _a.kind;
    if (userId === 0) {
        userId = (0, bootstrap_1.userIdFromDOM)();
    }
    (0, react_1.useEffect)(function () {
        if (!(0, preferencesStore_1.isPreferencesInitialised)()) {
            void (0, api_1.fetchAndInitPreferences)();
        }
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Toast_1.default, null),
        react_1.default.createElement(material_1.Accordion, { className: "msia-notifcations__detailAccordion", elevation: 0, sx: {
                mt: 2,
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 1,
                '&:before': { display: 'none' },
            } },
            react_1.default.createElement(material_1.AccordionSummary, { className: "msia-notifcations__detailAccordionSummary", expandIcon: react_1.default.createElement(ExpandMore_1.default, null) },
                react_1.default.createElement(material_1.Typography, { variant: "subtitle2", sx: { fontWeight: 600 } }, (0, Lang_js_1.__)('Notification settings for this type of message'))),
            react_1.default.createElement(material_1.AccordionDetails, { className: "msia-notifcations__detailAccordionDetails" },
                react_1.default.createElement(material_1.Stack, { spacing: 2 },
                    react_1.default.createElement(material_1.Box, null,
                        react_1.default.createElement(material_1.Typography, { variant: "caption", color: "text.secondary" }, (0, Lang_js_1.__)('Category')),
                        react_1.default.createElement(material_1.Typography, { variant: "body1", sx: { fontWeight: 500 } }, displayKindTitle(kind))),
                    react_1.default.createElement(KindChannelToggles_1.default, { kind: kind, userId: userId, size: "small" }),
                    react_1.default.createElement(material_1.Button, { size: "small", href: "/app/notifications/preferences/", sx: { alignSelf: 'flex-start', px: 0 } }, (0, Lang_js_1.__)('Manage all notification preferences')))))));
};
exports.default = NotificationPreferenceControls;
